<template>
  <div class="home" v-show="ticketDetail.id">
    <!-- mobile -->
    <!-- {{dataUrl}} -->
    <div v-if="$store.state.isMobile" class="phoneBg">
      <div v-if="appbanner && appbanner.length > 0" class="banner">
        <img :src="appbanner[0].fileUrl" alt="">
      </div>
      <div v-else class="banner"
        :style="`${!ticketDetail.museumImg ? `background:url(${imageStateUrl}${ticketDetail.museumImg}) center center no-repeat` : ''}`">
        <!-- <div class="phoneLogo"></div> -->

        <div class="phoneIconRight"></div>
        <div class="phoneIconLeft"></div>
        <div class="phoneFont1">在线</div>
        <div class="phoneFont2">预约</div>
      </div>
      <!-- <div v-else class="banner"
        :style="`${`background:url(https://museum.chaoxing.com/ticket/v3/212594.png) center center no-repeat;background-size:100% 100%;`}`">
        <div class="phoneLogo"></div>

        <div class="phoneIconRight"></div>
        <div class="phoneIconLeft"></div>
        <div class="phoneFont1">在线</div>
        <div class="phoneFont2">预约</div>
      </div> -->
      <div class="content homewrap" ref="homewrap">
        <div class="newNotice" @click="cgjj(2)" v-if="notice.dictName">
          <div class="noticeTitle" ref="noticeTitle">{{ notice.dictName }}：</div>
          <div ref="noticeWarp" class="noticeWarp" :style="`width: calc(100% - ${noticeTitleWidth}px - 0.4rem)`">
            <span ref="noticeContent" :style="contentStyle" v-if="ticketDetail.inform"
            v-html="notice.description"></span>
          </div>
        </div>
        <div class="newMiddle">
          <div class="title">{{ ticketDetail.ticketName }}</div>
          <div class="museumTimes">
            <div class="line">
              <div class="time">{{ ticketDetail.timeOpen }}</div>
              <span v-if="$store.state.museumCode*1!==212594">开始入馆时间</span>
              <span v-else>
                开馆时间
              </span>
            </div>
            <div class="line">
              <div class="time">{{ ticketDetail.timeStop }}</div>
              <span v-if="$store.state.museumCode*1!==212594">停止入馆时间</span>
              <span v-else>
                停止入馆
              </span>
            </div>
            <div class="line">
              <div class="time">{{ ticketDetail.timeClose }}</div><span>闭馆时间 </span>
            </div>
          </div>
          <div class="reservation" @click="reservation($store.state.ticketDetail.perOn ? 1 : 2)"
            v-if="$store.state.ticketDetail.perOn || $store.state.ticketDetail.orgOn">立即预约</div>
        </div>
        <div class="cgjjPlaceHolder"></div>
        <div class="cgjjBtn" @click="cgjj(1)">场馆简介</div>
      </div>
      <h5Bottom style="z-index: 33;" :activeIndex="1"></h5Bottom>
    </div>
    <!-- pc -->
    <div v-else class="pcHomeBg">
      <topBanner></topBanner>
      <div class="indexBanner" :style="`height: ${300 * scale}px`">
        <div class="topRightIcon"
          :style="`transform: scale(${scale}) rotate(180deg); top: ${50 * scale - 134 * (1 - scale) / 2}px`"></div>
        <div class="botLeftIcon" :style="`transform: scale(${scale}); bottom: ${50 * scale - 134 * (1 - scale) / 2}px`"></div>
        <div class="bannerFont" :style="`transform: scale(${scale});`">在线预约</div>
      </div>
      <div class="pcMiddle" :style="`height: ${140 * scale}px`">
        <div class="wrap1400 flex" :style="`transform: scale(${scale}); top: -${140 * (1 - scale) / 2}px`">
          <div>
            <div class="museumTimes">
              <div class="line">
                <div class="time">{{ ticketDetail.timeOpen }}</div><span>开始入馆时间 </span>
              </div>
              <div class="line">
                <div class="time">{{ ticketDetail.timeStop }}</div><span>停止入馆时间 </span>
              </div>
              <div class="line">
                <div class="time">{{ ticketDetail.timeClose }}</div><span>闭馆时间 </span>
              </div>
            </div>
            <div class="museumAddress" v-if="ticketDetail.address">
              <div>{{ ticketDetail.address }}</div><span>场馆地址</span>
            </div>
          </div>
          <div class="personalBtn" @click="toPersonalCenter" v-if="!isNaN(Number($route.query.museumCode))"><img
              src="../../assets/images/user_icon.png">个人中心</div>
          <div class="personalBtn" @click="myOrder" v-else>我的订单</div>
        </div>
      </div>
      <div class="wrap1400 promptBx" :style="`transform: scale(${scale});`">
        <div class="introductionBtn" @click="cgjj(1)">场馆简介</div>
        <div class="reservationBtn" @click="cgjj(2)">
          {{ notice.dictName }}：
          <div ref="noticeWarp" class="noticeWarp">
            <!-- <span ref="noticeContent" :style="contentStyle" >{{scrollDetail}}</span> -->
            <span ref="noticeContent" :style="contentStyle" v-if="ticketDetail.inform"
              v-html="notice.description"></span>
            <!-- <p v-if="ticketDetail.inform" v-html="notice.description"></p> -->
          </div>
        </div>
      </div>
      <div class="wrap1400 flex flexCenter" :style="`transform: scale(${scale});`">
        <div class="personalReservation" v-if="$store.state.ticketDetail.perOn">
          <div class="personalFont">个人<span>预约</span></div>
          <div class="personalReBtn" @click="reservation(1)">点击预约</div>
        </div>
        <div class="personalReservation group" v-if="$store.state.ticketDetail.orgOn">
          <div class="personalFont">团队<span>预约</span></div>
          <div class="personalReBtn" @click="reservation(2)">点击预约</div>
        </div>
      </div>
      <!-- <div class="scanCode" :style="`transform: scale(${scale}); margin-top: -${170*(1-scale)/2 - 40*scale}px`">
        <div class="img"><img src="../../assets/ticket/erCode_new.jpg"></div>
        <div class="codeFont">扫码预约</div>
      </div> -->
    </div>
    <div :class="$store.state.isMobile ? '' : 'pcHomeBg pcBg02'">
      <pop v-if="showPopPc == 1">
        <slot>
          <div class="popContent">
            <!--<div class="title"  v-if="showTitle">{{notice.dictName}}</div>-->
            <div :class="$store.state.isMobile ? 'title' : 'popTitle'">场馆简介</div>
            <div class="baseLine"></div>
            <div class="notice" v-html="ticketDetail.description"></div>
            <div class="buttonConfirm" @click="closePop" v-if="$store.state.isMobile">我知道了</div>
            <div class="popConfirm" @click="closePop" v-else></div>
          </div>
        </slot>
      </pop>
      <pop v-if="showPopPc == 2">
        <slot>
          <div class="popContent">
            <!--<div class="popTitle">{{ticketDetail.inform ? notice.dictName : '通知公告'}}</div>-->
            <div :class="$store.state.isMobile ? 'title' : 'popTitle'">{{ notice.dictName }}</div>
            <div class="baseLine"></div>
            <div class="notice">
              <p v-if="ticketDetail.inform" v-html="notice.description"></p>
              <p v-else>暂无</p>
            </div>
            <div class="buttonConfirm" @click="closePop" v-if="$store.state.isMobile">我知道了</div>
            <div class="popConfirm" @click="closePop" v-else></div>
          </div>
        </slot>
      </pop>
    </div>
  </div>
</template>

<script>
import pop from '../../components/common/pop.vue'
import topBanner from '../../components/common/topBanner'
import h5Bottom from '../../components/common/h5Bottom.vue'

export default {
  name: 'Home',

  data() {
    return {
      ticketDetail: {},
      statusText: ['停业', '开放', '约满'],
      showPop: false,
      notice: {},
      specialCodes: ['fcshzybwg', 'xeggmjng', 'ycsbwg'],
      showTitle: false,
      imageStateUrl: '',
      dataUrl: '',
      showPopPc: 0,
      contentStyle: {
        transitionDuration: '0s',
        transform: 'translateX(0px)'
      },
      wrapWidth: 0,
      contentWidth: 0,
      ingWidth: 0,
      time: 0,
      timer: null,
      convertSpeed: 1,
      scale: 1,
      scrollDetail: '',
      noticeTitleWidth: 0,
      appbanner: [],
      themetimer: null
    };
  },

  components: { pop, topBanner, h5Bottom },

  methods: {
    cgjj(type) {
      this.showPopPc = type
      console.log(type)
    },
    // 个人中心
    toPersonalCenter() {
      let query = this.$route.query
      delete query.loginType
      if (!this.$cookie.get('token') && this.$route.query.loginUrl) return location.href = this.$route.query.loginUrl
      if (!this.$cookie.get('token')) return this.$router.push({ name: 'login', query, params: { backOtherPage: 'personalCenter' } })
      query.rType = this.$store.state.ticketDetail.perOn ? 1 : 2
      // delete query.code
      // this.$router.push({path: '/ticket/orders', query})
      this.$router.push({ name: 'personalCenter', query })
    },
    reservation(type) {
      let query = this.$route.query
      delete query.loginType
      if (type) query.type = type
      if (!this.$cookie.get('token') && query.loginUrl) return location.href = query.loginUrl
      if (!this.$cookie.get('token') && !this.$cookie.get('ticket_number')) return this.$router.push({ name: 'login', query, params: { backOtherPage: 'reservation' } })
      // delete query.code
      this.$router.push({ path: '/ticket/reservation', query })
    },

    myOrder() {
      if (!this.$cookie.get('token') && this.$route.query.loginUrl) return location.href = this.$route.query.loginUrl
      if (!this.$cookie.get('token') && !this.$cookie.get('ticket_number')) return this.$router.push({ name: 'login', query: this.$route.query, params: { backOtherPage: 'orders' } })
      let query = this.$route.query
      query.rType = this.$store.state.ticketDetail.perOn ? 1 : 2
      // delete query.code
      this.$router.push({ path: '/ticket/orders', query })
    },

    closePop() {
      this.showPop = false
      this.showPopPc = 0
    },

    getticketDetail() {
      if (this.$store.state.ticketDetail.id) {
        this.ticketDetail = this.$store.state.ticketDetail

        // this.ticketDetail.description = this.ticketDetail.description.replaceAll('\"', '"')
        // this.ticketDetail.description = this.ticketDetail.description.replaceAll('\"', '"')
        // 判断是否显示标题
        let date = 1648713588000 //2022/3/31日之后的馆都不显示场馆简介四个字，需要的可以在富文本添加
        if (Date.parse(this.ticketDetail.crtTime) < date && this.specialCodes.indexOf(this.$route.query.museumCode) == -1) {
          this.showTitle = true
        }
        if (!this.ticketDetail.inform) return
        return this.getInfo(this.ticketDetail.inform)
      }
      let url = this.$route.query.code ? `/api/ticket/front/ticket-info/code?museumCode=${this.$store.state.museumCode}&code=${this.$route.query.code}` : `/api/ticket/front/ticket-info?museumCode=${this.$store.state.museumCode}${this.$route.query.id ? `&ticketInfoId=${this.$route.query.id}` : ''}`
      this.$ajax.get(url).then((res) => {
        this.$store.state.ticketDetail = res.data[0]
        this.ticketDetail = this.$store.state.ticketDetail
        // this.ticketDetail.description = this.ticketDetail.description.replaceAll('\"', '"')
        // this.ticketDetail.description = this.ticketDetail.description.replaceAll('\"', '"')
        // 判断是否显示标题
        document.title = this.$store.state.ticketDetail.ticketName
        let date = 1648713588000 //2022/3/31日之后的馆都不显示场馆简介四个字，需要的可以在富文本添加
        if (Date.parse(this.ticketDetail.crtTime) < date && this.specialCodes.indexOf(this.$route.query.museumCode) == -1) {
          this.showTitle = true
        }
        if (!this.ticketDetail.inform) return
        this.getInfo(this.ticketDetail.inform)
      })
    },

    getInfo(code) {
      this.$ajax(`/api/admin/front/dict/codeDictAll/${code}?museumCode=${this.$store.state.museumCode}&dictCode=${code}`).then((res) => {
        this.notice = res.data ? res.data : {}
        this.$nextTick(() => {
          // console.log()
          this.init()
        })
        if (this.$store.state.hasShowPop) return
        this.showPop = true
        this.$store.state.hasShowPop = true
      })
    },

    getMuseum() {
      this.$ajax(`/api/admin/front/group/name?museumCode=${this.$store.state.museumCode}`).then((res) => {
        this.$store.state.museumName = res.data
      })
    },

    // 从微服务带来的token
    getTokenByLoginApp() {
      let fid = this.$cookie.get('fid')
      if (!fid || (fid != this.$route.query.museumCode) || this.$cookie.get('token')) return
      this.$ajax.post(`/api/auth/jwt/login-app?fid=${fid}`).then((res) => {
        this.$cookie.set('token', res.data.token)
        var pat = /(\d{3})\d*(\d{4})/;
        let phone = res.data.mobilePhone.replace(pat, '$1****$2');
        this.$cookie.set('ticket_phone', phone)
      })
    },

    getCode() {
      this.$ajax(`/api/admin/front/dict/codeDictAll/ticket.title.${this.$route.query.museumCode}`).then((res) => {
        if (res.data && res.data.dictName) return document.title = res.data.dictName
        document.title = '票务预约'
      })
    },

    // 蒙速办的code
    getTokenByCode() {
      this.$ajax(`/api/auth/jwt/msb?museumCode=${this.$store.state.museumCode}&code=${this.$route.query.code}`).then((res) => {
        if (this.$cookie.get('token')) {
          this.$cookie.delete('token')
          this.$cookie.delete('ticket_phone')
        }
        this.$cookie.set('token', res.data.token)
        var pat = /(\d{3})\d*(\d{4})/;
        let phone = res.data.user.mobilePhone.replace(pat, '$1****$2');
        this.$cookie.set('ticket_phone', phone)
      })
    },

    init() {
      console.log(this.$refs.noticeTitle)
      console.log(this.$refs.noticeContent)
      // this.noticeTitleWidth = this.$refs.noticeTitle.offsetWidth
      this.contentWidth = this.$refs.noticeContent.offsetWidth
      this.wrapWidth = this.$refs.noticeWarp.offsetWidth

      if (this.contentWidth <= this.wrapWidth) return
      this.startAnimate()
      this.timer = setInterval(() => {
        this.startAnimate()
      }, 1000)
      this.$once('hook:beforeDestroy', () => {
        clearInterval(this.timer)
        this.timer = null
      })
    },
    startAnimate() {
      this.time = 1
      this.ingWidth += 10
      this.contentStyle.transitionDuration = this.time + 's'
      this.contentStyle.transform = 'translateX(-' + this.ingWidth + 'px)'
      if (this.ingWidth >= this.contentWidth - this.wrapWidth) {
        this.scrollDetail += this.scrollDetail
        this.contentWidth = this.$refs.noticeContent.offsetWidth
        // clearInterval(this.timer)
        // this.timer = null
      }
      // console.log('this.scrollDetail')
      // console.log(this.scrollDetail)
    },

    // 增加访问量
    setViewNum() {
      this.$ajax.put(`/api/portal/front/click-count/add/${this.$route.query.museumCode}`).then(() => {

      })
    }
  },

  created() {
    this.setViewNum()
    if (window.innerHeight < 1200) {
      // console.log(window.innerHeight)
      this.scale = window.innerHeight / 1170
    }
    window.onresize = () => {
      return (() => {
        if (window.innerHeight < 1200) {
          // console.log(window.innerHeight)
          this.scale = window.innerHeight / 1170
        }
      })();
    };
    this.dataUrl = location.href
    // this.getCode()
    if (this.$route.query.token) {
      if (this.$cookie.get('token')) {
        this.$cookie.delete('token')
        this.$cookie.delete('ticket_phone')
      }
      this.$cookie.set('token', this.$route.query.token)
      let phone = this.$route.query.phone
      var pat = /(\d{3})\d*(\d{4})/;
      phone = phone.replace(pat, '$1****$2');
      this.$cookie.set('ticket_phone', phone)
    }
    this.$store.state.museumCode = this.$route.query.museumCode
    if (this.$route.query.code && !this.$store.state.hasGetCode && this.$route.query.museumCode == 'xabwg') {
      this.$store.state.hasGetCode = true
      this.getTokenByCode()
    }
    this.imageStateUrl = !isNaN(Number(this.$store.state.museumCode)) ? '' : Glob.imgUrl
    this.$cookie.set('museumCode', this.$route.query.museumCode)
    if (this.$route.query.id) {
      this.$cookie.set('ticketId', this.$route.query.id)
    }
    this.getticketDetail()
    if (this.$cookie.get('_uid') && this.$cookie.get('fid') && this.$cookie.get('_d')) {
      this.getTokenByLoginApp()
    }
    if (this.$store.state.museumName) return
    this.getMuseum()
  },
  mounted () {
    let that = this
    this.themetimer = setInterval(() => {
      if (Object.keys(this.$store.state.themeData).length > 0) {
        that.appbanner = that.$store.state.themeData.appbanner
        clearInterval(that.themetimer)
        let indexbg = that.$store.state.themeData.apphomebg
        if (indexbg && indexbg.length > 0) {
          document.querySelector('.homewrap').style.backgroundImage = `url('${indexbg[0].fileUrl}')`
        }
      }
    }, 100)
  }
}
</script>

<style scoped lang="scss">
.home {

  // font-family: STZHONGS;
  .contentCard {
    height: calc(100vh - 11.5rem);
    overflow-y: scroll;
  }

  .notice {
    text-align: left;
  }

  .banner {
    height: 8rem;
    width: 10rem;
    // background: url('~@/assets/ticket/mobileBg.svg') 0 0/100% no-repeat;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
    img{
      width: 100%;
    }

    &:before {
      width: 5.6rem;
      height: 4.9rem;
      position: absolute;
      content: '';
      display: inline-block;
      // background:url(../../assets/ticket/yun1.png) 0 0/contain no-repeat;
      bottom: 1rem;
      left: -1rem;
    }

    &:after {
      width: 5.6rem;
      height: 4.3rem;
      position: absolute;
      content: '';
      display: inline-block;
      // background:url(../../assets/ticket/yun2.png) 0 0/contain no-repeat;
      right: 0;
      bottom: 1rem;
    }

    .phoneLogo {
      position: absolute;
      width: 4rem;
      height: .86rem;
      background: url(../../assets/ticket/titleLogo.png) no-repeat;
      background-size: 100%;
      top: .44rem;
      left: .7rem
    }

    .phoneIconRight {
      position: absolute;
      width: .36rem;
      height: 1.1rem;
      background: url(../../assets/images/bannerIcon.png) no-repeat;
      background-size: 100%;
      top: .8rem;
      right: .8rem;
      transform: rotate(180deg)
    }

    .phoneIconLeft {
      position: absolute;
      width: .36rem;
      height: 1.1rem;
      background: url(../../assets/images/bannerIcon.png) no-repeat;
      background-size: 100%;
      top: 4.4rem;
      left: .8rem;
    }

    .phoneFont1,
    .phoneFont2 {
      position: absolute;
      color: #FFE4BC;
      top: 1.5rem;
      right: 4.2rem;
      font-size: 0.4rem;
      writing-mode: lr-tb;
      width: 0.45rem;
    }

    .phoneFont1:after {
      width: 0.3rem;
      height: 0.52rem;
      background: url(../../assets/ticket/home_icon1.png) 0 0/100% no-repeat;
      content: '';
      display: inline-block;
    }

    .phoneFont2:after {
      width: 1.1rem;
      height: 0.29rem;
      background: url(../../assets/ticket/home_icon2.png) 0 0/100% no-repeat;
      content: '';
      display: inline-block;
      transform: translateX(-2.3rem);
    }

    .phoneFont2 {
      right: 4.8rem;
      top: 2.2rem;
    }
  }

  .content {
    border-radius: 0.7rem 0.7rem 0rem 0rem;
    margin-top: 5.4rem;
    min-height: calc(100vh - 5.4rem);
    background: url(../../assets/newImages/homeBg.png) top center no-repeat;
    background-size: cover;
    z-index: 2;
    position: relative;

    .title {
      padding-top: 1rem;
      font-size: 0.7rem;
      line-height: 1rem;
      font-weight: 510;
    }

    .status {
      position: absolute;
      top: -0.1rem;
      right: 0.9rem;
      width: 0.3rem;
      font-size: 0.3rem;
      color: #fff;
      line-height: 0.4rem;
      padding: 0.35rem 0.2rem 0.45rem 0.2rem;
    }

    .status::after {
      display: block;
      content: '';
      width: 0;
      height: 0;
      border-left: 0.35rem solid transparent;
      border-right: 0.35rem solid transparent;
      border-bottom: 0.35rem solid #fff;
      position: absolute;
      bottom: -0.02rem;
      right: 0;
    }

    .status_g {
      background-color: #7fa704;
    }

    .status_r {
      background-color: red;
    }

    .status_y {
      background-color: yellow;
    }

    .museumTime {
      margin-top: 0.3rem;
      font-size: 0.36rem;
      line-height: 0.65rem;
    }

    .cardTitle {
      font-size: 0.5rem;
      font-weight: 500;
      margin-bottom: 0.2rem;
    }

    .tips {
      font-size: 0.4rem;
      line-height: 0.65rem;
    }

    .buttons {
      margin-top: 0.7rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .reservation {
        margin: 0 0.5rem 0 3rem;
        position: relative;
      }

      .myOrder {
        font-size: 0.42rem;
        font-weight: 800;
        display: inline-block;
      }
    }
  }

  .phoneBg {

    // font-family: STZHONGS;
    .newNotice {
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08);
      padding: 0 .4rem;
      border-radius: .5rem;
      height: .9rem;
      line-height: .9rem;
      font-size: .4rem;
      color: #8A0C0C;
      background: url(../../assets/images/phoneNotice.png) no-repeat .4rem center #FFFAF2;
      background-size: .6rem;
      padding-left: .4rem;
      white-space: nowrap;
      overflow: height;
      position: relative;
      display: flex;
      align-items: center;
      padding-left: 1rem;

      .noticeTitle {
        display: inline-block;
      }

      .noticeWarp {
        display: inline-block;
        font-size: .36rem;
        color: #343434;
        overflow: hidden;

        span {
          // position: absolute;
          font-size: .36rem;
          display: inline-block;
          vertical-align: middle;
          transition-timing-function: linear;
        }
      }

      &::after {
        content: '';
        position: absolute;
        width: .2rem;
        height: .5rem;
        background: url(../../assets/images/rightArr.png) no-repeat;
        background-size: 100%;
        right: .4rem;
        top: .3rem
      }
    }

    .newMiddle {
      background: url(../../assets/images/floor.png) no-repeat;
      background-size: 100%;
      width: 10rem;
      height: 7.5rem;
      margin: 0 auto;
      border-radius: .26rem;
      overflow: hidden;
      padding: 0 .45rem;
      box-sizing: border-box;

      .title {
        padding: 0;
        height: 1.4rem;
        background: url(../../assets/images/xiangyun.jpg) no-repeat;
        border-radius: .26rem .26rem 0 0;
        font-size: .65rem;
        color: #000;
        // font-family: STZHONGS;
        line-height: 1.4rem;
        margin-top: .5rem
      }

      .museumTimes {
        height: 2.8rem;
        display: flex;
        align-items: center;
        justify-content: space-around;
        position: relative;

        &::before {
          content: '';
          position: absolute;
          width: 0.26rem;
          height: .26rem;
          background: url(../../assets/images/timesIcon.png) no-repeat;
          background-size: 100%;
          left: 33%;
          top: 40%
        }

        &::after {
          content: '';
          position: absolute;
          width: 0.26rem;
          height: .26rem;
          background: url(../../assets/images/timesIcon.png) no-repeat;
          background-size: 100%;
          left: 69%;
          top: 40%
        }

        .time {
          font-size: .65rem;
          line-height: .8rem;
          height: .8rem;
          color: #BE871A;
        }

        .line {
          display: flex;
          flex-direction: column;
          align-items: center;

          span {
            font-size: .4rem;
            line-height: .65rem;
            margin-top: .05rem;
          }
        }
      }

      .reservation {
        width: 7.8rem;
        height: 1.2rem;
        border-radius: .68rem;
        color: #fff;
        margin: .65rem auto 0 auto;
        font-size: .5rem;
        line-height: 1.2rem;
      }
    }

    .cgjjPlaceHolder {
      height: 4rem;
    }

    .cgjjBtn {
      position: absolute;
      width: .8rem;
      height: 1.8rem;
      background: #FFFFFF;
      box-shadow: 0px 1px 12.5px rgba(0, 0, 0, 0.15);
      border-radius: .26rem 0px 0px .26rem;
      right: 0;
      top: 8.5rem;
      color: #931D1B;
      font-size: .3rem;
      line-height: .39rem;
      padding: 0 .2rem;
      box-sizing: border-box;
      display: flex;
      align-items: center;
    }
  }

  .popContent {

    // padding: 0.4rem 0.5rem;
    .title {
      font-size: 0.5rem;
      font-weight: 500;
      text-align: center;
    }

    .notice {
      font-size: 0.4rem;
      max-height: 60vh;
      
      overflow: scroll;
      color: #535353;
      position: relative;
      width: 8.3rem;
    }

  }

  .pcContent {
    .pcItemCard {
      padding: 35px 70px;
    }
  }

  .topContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 40px;

    img {
      width: 750px;
      height: 420px;
      border-radius: 30px;
    }
  }

  .handelBlock {
    width: 365px;
    margin-right: 20px;

    .line {
      font-size: 22px;
      font-weight: 500;
      text-align: left;
      line-height: 40px;
      margin-left: 15px;

      span {
        margin-left: 25px;
        font-size: 20px;
      }
    }
  }

  .button2 {
    margin-top: 30px;
    display: inline-block;

    &:nth-child(1) {
      margin-right: 39px;
    }
  }

  .button3 {
    margin: auto;
    margin-top: 0.2rem;
  }

  .pcItemCard {
    // padding: 0.2rem 0.5rem;
    overflow: hidden;

    .lineBgc {
      background: unset;
      padding: 0;
    }

    // .left, .right{
    //   width: 4rem;
    //   font-size: 0.13rem;
    //   text-align: left;
    // }
    // .title{
    //   text-align: center;
    //   font-weight: 500;
    //   font-size: 0.15rem;
    // }
    // .left{
    //   margin-right: 0.5rem;
    // }
  }

  .pcHomeBg {
    min-width: 1400px;

    &::after {
      content: '';
      background: url(../../assets/images/homeBg.jpg) no-repeat;
      background-size: cover;
      min-height: 100vh;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0%;
      z-index: -3;
      position: fixed;
    }

    .indexBanner {
      height: 300px;
      min-width: 1400px;
      // background:url(../../assets/images/indexBanner.jpg) no-repeat center;
      background-size: cover;
      position: relative;

      .topRightIcon {
        width: 45px;
        height: 134px;
        background: url(../../assets/images/bannerIcon.png) no-repeat;
        transform: rotate(180deg);
        position: absolute;
        top: 50px;
        right: 80px;
      }

      .botLeftIcon {
        width: 45px;
        height: 134px;
        background: url(../../assets/images/bannerIcon.png) no-repeat;
        position: absolute;
        bottom: 50px;
        left: 80px;
      }

      .bannerFont {
        margin: auto;
        width: 100%;
        text-align: center;
        font-size: 68px;
        color: #FFE4BC;
        font-family: FZDBSJW;
        font-weight: 400;
        position: absolute;
        top: 25%;
        letter-spacing: 13.6px;
        // background: url(../../assets/images/font.png) no-repeat 100%;
      }

      &:before {
        position: absolute;
        width: 100%;
        height: 100%;
        content: '';
        display: inline-block;
        background-color: #ffffff33;
        -webkit-mask: url('~@/assets/images/pcTopBg.svg') 0 0/cover no-repeat;
        mask: url('~@/assets/images/pcTopBg.svg') 0 0/cover no-repeat;
        left: 0;
        bottom: 0;
      }
    }

    .pcMiddle {
      height: 140px;
      position: relative;
      // font-family: STZHONGS;
      box-shadow: 0px 4px 20px rgba(57, 54, 48, 0.04);

      .wrap1200 {
        height: 140px;
      }

      .wrap1400 {
        height: 140px;
        width: 1400px;
        position: absolute;
        top: 0;
        left: calc(50vw - 700px);
      }

      &::after {
        background: url(../../assets/images/xiangyun.jpg) repeat;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: -2;
        content: '';
      }

      .personalBtn {
        width: 238px;
        height: 80px;
        line-height: 80px;
        margin: 0;
        position: relative;
        cursor: pointer;
        color: #FFE4BC;
        font-size: 30px;

        // font-family: STZHONGS;
        img {
          display: inline-block;
          vertical-align: middle;
          margin-right: 13px;
          height: 28px;
          width: 28px;
          margin-bottom: 4px;
        }

        &::after {
          content: '';
          // background:url(../../assets/ticket/personalCenter.svg) no-repeat;
          -webkit-mask: url('~@/assets/ticket/personalCenter.svg') 0 0/100%no-repeat;
          mask: url('~@/assets/ticket/personalCenter.svg') 0 0/100% no-repeat;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index: -1
        }
      }

      .museumTimes {
        position: relative;
        float: left;

        &::before,
        &::after {
          content: '';
          width: 20px;
          height: 20px;
          background: url(../../assets/images/timesIcon.png) no-repeat;
          position: absolute;
          top: 38px;
          left: 135px
        }

        &::after {
          left: 320px
        }

        .line {
          float: left;
          margin-right: 60px;

          .time {
            font-size: 40px;
            // color:#9A0B0B;
            line-height: 53px;
            height: 53px;
          }

          span {
            font-size: 20px;
            line-height: 27px;
            margin: 0;
            padding: 0
          }
        }
      }

      .museumAddress {
        float: left;
        text-align: left;

        div {
          font-size: 26px;
          // color:#9A0B0B;
          height: 53px;
          line-height: 53px;
        }

        span {
          font-size: 20px;
          line-height: 27px;
        }
      }
    }

    .wrap1400 {
      width: 1400px;
      margin: 0 auto;
    }

    .flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .flexCenter {
      justify-content: space-around;
    }

    .personalReservation {
      width: 680px;
      height: 220px;
      // background:url(../../assets/images/personalbg.png) no-repeat right bottom #901111;
      margin-top: 40px;
      border-radius: 20px;
      box-shadow: 0 10px 10px rgba(0, 0, 0, .2);
      position: relative;

      &:before {
        background: url(../../assets/images/homeBtnBg.png) 0 0/cover no-repeat;
        position: absolute;
        width: 100%;
        height: 100%;
        content: '';
        display: inline-block;
        top: 0;
        left: 0;
      }

      // font-family: STZHONGS;
      .personalFont {
        color: #fff;
        // text-shadow: 0px 2px 0px rgba(0, 0, 0, 0.15);
        font-size: 56px;
        // font-family: STZHONGS;
        position: absolute;
        top: 24px;
        left: 50px;
        line-height: 74px;

        span {
          font-size: 40px
        }
      }

      .personalReBtn {
        width: 153px;
        height: 50px;
        right: 50px;
        bottom: 30px;
        position: absolute;
        background: #FFFFFF;
        border-radius: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 24px;
        padding-right: 20px;

        &:after {
          width: 24px;
          height: 9px;
          position: absolute;
          content: '';
          display: inline-block;
          -webkit-mask: url('~@/assets/images/union.svg') 0 0/100% 100% no-repeat;
          mask: url('~@/assets/images/union.svg') 0 0/100% 100% no-repeat;
          right: 15px;
          top: 20px;
        }
      }
    }

    .promptBx {
      margin-top: 40px;
      // font-family: STZHONGS;
      font-size: 22px;
      line-height: 26px;
      display: flex;
      align-items: center;
      letter-spacing: 0.04em;

      .introductionBtn {

        // background:url(../../assets/images/instructionIcon.png) no-repeat left center;
        &:before {
          display: inline-block;
          content: '';
          -webkit-mask: url('~@/assets/images/instructionIcon.svg') no-repeat left center;
          mask: url('~@/assets/images/instructionIcon.svg') no-repeat left center;
          width: 26px;
          height: 26px;
          position: absolute;
          left: 0;
        }

        padding-left:32px;
        margin-right:50px;
        position: relative;
        // color: #8A0C0C;
        width:136px;
        cursor:pointer;
        box-sizing: border-box;

        &::after {
          position: absolute;
          content: '';
          width: 1px;
          height: 24px;
          background: var(--themeColor);
          top: 1px;
          right: -24px
        }
      }

      .reservationBtn {
        &:before {
          display: inline-block;
          content: '';
          -webkit-mask: url('~@/assets/images/reservationBtn.svg') no-repeat left center;
          mask: url('~@/assets/images/reservationBtn.svg') no-repeat left center;
          width: 26px;
          height: 26px;
          position: absolute;
          left: 0;
        }

        padding-left:32px;
        margin-right:10px;
        position: relative;
        // color: #8A0C0C;
        cursor:pointer;
        width: calc(100% - 235px);
        box-sizing: border-box;
        white-space: nowrap;
        // padding-right:0px;
        display: flex;
        align-items: center;

        &::after {
          background: url(../../assets/images/rightOrder.png) no-repeat right center;
          /* background:url(../../assets/images/rightArr.png) no-repeat right center;*/
          width: 24px;
          height: 27px;
          background-size: 24px;
          height: 27px;
          content: '';
          position: absolute;
          right: -50px;
          top: 0;
        }

        .noticeWarp {
          position: relative;
          display: inline-block;
          width: 100%;
          overflow: hidden;
          text-align: left;

          span {
            // position: absolute;
            font-size: 20px;
            color: #333;
            display: inline-block;
            vertical-align: middle;
            transition-timing-function: linear;
          }
        }

      }

    }

    .scanCode {
      text-align: center;
      font-size: 22px;
      color: #8A0C0C;
      line-height: 24px;

      // margin-top:40px;
      .img {
        margin: 0 auto;
        width: 136px;
        height: 136px;
        border: 2px solid #8A0C0C;
        border-radius: 20px;
        padding: 5px;
        margin-bottom: 10px;

        img {
          width: 136px;
          height: 136px;
          display: block;
        }
      }

      .codeFont {
        margin: 10px auto 28px auto
      }
    }

    .pcPop {
      .popConfirm {
        position: absolute;
        right: 20px;
        top: 20px;
        width: 28px;
        height: 28px;
        background: url(../../assets/images/popClose.png) no-repeat;
        cursor: pointer;
      }

      .popTitle {
        font-size: 36px;
        line-height: 48px;
        color: #8A0C0C
      }

      .notice {
        max-height: 50vh !important;
        font-size: 20px !important;
        line-height: 32px !important;
        position: relative;
        color: #535353;
      }

      .baseLine {
        width: 370px !important;
        height: 18px !important;
        margin: 26px auto !important;
      }
    }

  }

  .pcBg02 {
    ::v-deep.pcPop {
      width: 1200px !important;
      margin-left: calc(50% - 600px);
      width: 1200px;
      min-height: 60vh;
    }
  }
}
</style>
<style type="text/css" lang="scss">
.home {
  .noticeWarp {
    span {
      p {
        margin: 0;
        display: inline-block;
      }
    }
  }
}
</style>